export enum DomainPermission {
    ALLOW = 'IS_ALLOWED',
    BLOCK = 'IS_BLOCKED'
}
